import signedFetch from '../util/signedFetch.js';

export default ({ sessionId }) =>
  signedFetch(
    'loadPlacementTestReportCard',
    `${__API_BASE__}/placementTest/${sessionId}/results/reportCards?format=pdf`,
    'GET'
  );
